import URI from 'urijs';
import { IUrl, IUrlService } from './types';

export class Url implements IUrl {
    private url: URI;

    constructor(private urlService: IUrlService, url: string) {
        this.url = new URI(url);
    }

    clone(): IUrl {
        return new Url(this.urlService, this.url.toString());
    }

    commitReplace(): void {
        this.urlService.updateUrl(this);
    }

    commitPush(): void {
        this.urlService.pushUrl(this);
    }

    getParam(param: string): string {
        return this.getSearchObject()[param];
    }

    updateParam(param: string, value: string): IUrl {
        this.url.removeSearch(param);
        this.url.addSearch(param, value);

        return this;
    }

    setProtocol(protocol: string): IUrl {
        this.url.protocol(protocol);

        return this;
    }

    setSearch(searchObject: Record<string, any>): IUrl {
        this.url.setSearch(searchObject);

        return this;
    }

    toUrlString(): string {
        return this.url.toString();
    }

    appendPath(path: string): IUrl {
        this.url.segment(path);

        return this;
    }

    getProtocol(): string {
        return this.url.protocol();
    }

    getHost(): string {
        return this.url.host();
    }

    getPort(): string {
        return this.url.port();
    }

    getPath(): string {
        return this.url.path();
    }

    getQuery(): string {
        return this.url.query();
    }

    getHostName(): string {
        return this.url.hostname();
    }

    getPathSegments(): string[] {
        return this.url.segment();
    }

    getHash(): string {
        return this.url.hash();
    }

    getSearchObject(): Record<string, any> {
        return this.url.search(true);
    }

    removeOrigin(): IUrl {
        this.url.origin('');

        return this;
    }
}
